import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Spending money online is crazy hard!",
  "description": "",
  "published": "2011-09-24T00:00:00.000Z",
  "redirect_from": ["/blog/spending-money-online-is-crazy-hard/swizec/2479"],
  "categories": "Business, Credit card, MasterCard, MoneyBookers, Spotify, Uncategorized, VISA",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/09/Credit_card3.jpg",
        "alt": "Credit card",
        "title": "Credit card"
      }}></img></p>
    <p>{`Today `}<a parentName="p" {...{
        "href": "http://www.spotify.com/",
        "title": "Spotify"
      }}>{`Spotify`}</a>{` finally realized I am not just traveling around Europe, but intend to stay here a while. Their 14 day travel grace period lasted a month and a half and I think that's awesome! While I was using Spotify I got so used to the service I decided to actually pay for a premium account just so I could continue using it despite living in a country that officially isn't supported.`}</p>
    <p>{`The fact I got around their copyright restrictions might make me a criminal in some sense of the word. Fraud? EULA breaking? Who cares ...`}</p>
    <p>{`Here are the hoops I had to jump through to get a Spotify Premium account:`}</p>
    {
      /*more*/
    }
    <ol>
      <li parentName="ol">{`The whole process started two weeks ago by getting a `}<a parentName="li" {...{
          "href": "http://www.moneybookers.com/",
          "title": "Moneybookers"
        }}>{`moneybookers.com`}</a>{` account`}</li>
      <li parentName="ol">{`Then I had to send MoneyBookers photos of my passport and a recent bank statement to verify my address and identity`}</li>
      <li parentName="ol">{`After waiting a few days for my identity to be processed, I applied to get a MoneyBookers Mastercard`}</li>
      <li parentName="ol">{`Then I waited about two weeks`}</li>
      <li parentName="ol">{`When the card arrived I became the proud owner of a legal UK credit card that I can now use whenever I need a UK payment method`}</li>
      <li parentName="ol">{`On Spotify I changed my location to United Kingdom`}</li>
      <li parentName="ol">{`After that I clicked a few buttons and entered the details of my UK credit card to begin the payment process`}</li>
      <li parentName="ol">{`It didn't work`}</li>
      <li parentName="ol">{`Then I remembered I first had to upload funds from my VISA to the MoneyBookers account`}</li>
      <li parentName="ol">{`On MoneyBookers I clicked the big shiny "Upload Funds" button and selected my `}<a parentName="li" {...{
          "href": "http://www.corporate.visa.com",
          "title": "Visa Inc."
        }}>{`VISA card`}</a></li>
      <li parentName="ol">{`I was redirected to a `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/3-D_Secure",
          "title": "3-D Secure"
        }}>{`Verified By VISA`}</a>{` page`}</li>
      <li parentName="ol">{`Because they have a weird `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Password_policy",
          "title": "Password policy"
        }}>{`password policy`}</a>{` of allowing a maximum of 12 characters none of my usual secure passwords worked and I was redirected back to MoneyBookers with a big fat FAIL and told to contact my bank because I'm obviously doing something stupid`}</li>
      <li parentName="ol">{`Tried it again and this time 'round just claimed I had forgotten my Verified By VISA password and was asked for my tax number`}</li>
      <li parentName="ol">{`Got a new password for that thing ... I won't remember it next time, so it's effectively my tax number ... I guess. Basically anyone who has ever done business with me knows all the data needed to abuse my main credit card. Awesome.`}</li>
      <li parentName="ol">{`Great, now there was enough money on my MoneyBookers account to fund the purchase with the UK `}<a parentName="li" {...{
          "href": "http://www.mastercard.com/",
          "title": "MasterCard"
        }}>{`MasterCard`}</a></li>
      <li parentName="ol">{`Now I just clicked "Yes Please" on Spotify and voila, the premium account was mine! All mine!`}</li>
    </ol>
    <p>{`Sixteen steps to make a relatively simple purchase!`}</p>
    <p>{`Something I'm sure the Spotify guys have spent a lot of time polishing and making as frictionless as possible. Their part was truly frictionless.`}</p>
    <p>{`Well except for the silly thing where as a person from Slovenia I'm not supposed to be able to even use the service despite wanting to pay for it. But screw that, I'm sure the copyright holders of their music have some sort of reason for that ...`}</p>
    <p>{`Point is, each of these steps when looked at individually makes sense, it increases security, makes it harder for people to, basically, break the law. But when looked at it as a system it is completely and utterly bollocks! A useless piece of crap one might say.`}</p>
    <p>{`I wish it was as easy spending money online as it is in the real world. Not like the internet is inherently any less secure and we need all these hoops to jump through ...`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://gunnalag.wordpress.com/2011/09/15/registering-visa-credit-cards-what-is-verified-by-visa-vbv/"
        }}>{`Registering VISA Credit Cards: What is Verified By Visa (VBV)?`}</a>{` (gunnalag.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://pocketnow.com/smartphone-news/spotify-dropping-invite-requirement-offering-six-months-free"
        }}>{`Spotify Dropping Invite Requirement, Offering Six Months Free`}</a>{` (pocketnow.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://valeriewire.wordpress.com/2011/09/23/the-musical-magic-of-spotify/"
        }}>{`The Musical Magic of Spotify`}</a>{` (valeriewire.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://gizmodo.com/5843063/everyone-can-now-sign-up-for-spotify"
        }}>{`Everyone Can Now Sign Up for Spotify `}{`[`}{`Spotify`}{`]`}</a>{` (gizmodo.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.digitaltrends.com/music/indie-labels-say-there-is-no-upside-to-spotify/"
        }}>{`Indie labels say there is 'no upside' to Spotify`}</a>{` (digitaltrends.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://go.theregister.com/feed/www.theregister.co.uk/2011/09/20/google_wallet_visa/"
        }}>{`Google Wallet pockets Visa`}</a>{` (go.theregister.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://alecnewcomb.com/2011/09/23/spotify-review/"
        }}>{`Spotify Review`}</a>{` (alecnewcomb.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=aec85b23-f956-44d8-8703-b57b646b034f",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      